import { OptionsObject } from "src/app/shared-components/ev-dropdown/ev-dropdown.component";
import { IProjectStageDto } from "src/models/new-dwelling/new-dwelling.model";

export const newDwellingListSortOptions: OptionsObject[] = [
    { key: "projectName", displayValue: "Tittel\u00A0\u00A0 A – Å" },
    { key: "-projectName", displayValue: "Tittel\u00A0\u00A0 Å – A" },
    { key: "-numUnits", displayValue: "Enheter\u00A0\u00A0 Mange – Få" },
    { key: "numUnits", displayValue: "Enheter\u00A0\u00A0 Få – Mange" },
    { key: "-numStages", displayValue: "Trinn\u00A0\u00A0 Mange – Få" },
    { key: "numStages", displayValue: "Trinn\u00A0\u00A0 Få – Mange" },
    { key: "-soldShare", displayValue: "Solgt\u00A0\u00A0 Høy – Lav" },
    { key: "soldShare", displayValue: "Solgt\u00A0\u00A0 Lav – Høy" },
];

export const defaultListSortKey = "projectName";

const nbCollator = new Intl.Collator("nb", { numeric: true, sensitivity: "base" });

export function compareProjectStagesBy(sortKey: string): (a: IProjectStageDto, b: IProjectStageDto) => number {
    const descending = sortKey?.startsWith("-");
    const field = descending ? sortKey.substring(1) : sortKey;
    const direction = descending ? -1 : 1;

    return (a, b) => {
        let result: number;

        switch (field) {
            case "numUnits":
                result = (a?.numUnits ?? 0) - (b?.numUnits ?? 0);
                break;
            case "numStages":
                result = (a?.numStages ?? 0) - (b?.numStages ?? 0);
                break;
            case "soldShare":
                result = soldShare(a) - soldShare(b);
                break;
            default:
                result = nbCollator.compare(a?.projectName ?? "", b?.projectName ?? "");
        }

        // Fall tilbake på navn ved likhet, slik at rekkefølgen er stabil mellom sorteringer.
        return result !== 0 ? result * direction : nbCollator.compare(a?.projectName ?? "", b?.projectName ?? "");
    };
}

function soldShare(stage: IProjectStageDto): number {
    return stage?.numUnits > 0 ? stage.numberSold / stage.numUnits : 0;
}
